// extracted by mini-css-extract-plugin
export var arrows = "_1y-6";
export var decrementer = "_1y-a";
export var disabled = "_1y-4";
export var error = "_1y-1";
export var hiddenText = "_1y-b";
export var incrementer = "_1y-9";
export var input = "_1y-8";
export var inputWrapper = "_1y-0";
export var leadingIcon = "_1y-c";
export var readonly = "_1y-3";
export var regular = "_1y-7";
export var small = "_1y-5";
export var warning = "_1y-2";